import { render, staticRenderFns } from "./home4.vue?vue&type=template&id=a04e9fec&"
import script from "./home4.vue?vue&type=script&lang=js&"
export * from "./home4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports